import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=2a5dd1c4&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=js&"
export * from "./BaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=2a5dd1c4&prod&lang=stylus&"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=2a5dd1c4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5dd1c4",
  null
  
)

export default component.exports